import PausePopup from '@/objects/pausePopup';
import HelpPopup from '../objects/helpPopup';

export default class BaseScene extends Phaser.Scene {

  /**
                 *  A sample Game scene, displaying the Phaser logo.
                 *
                 *  @extends Phaser.Scene
                 */


  /**
                 *  Called when a scene is initialized. Method responsible for setting up
                 *  the game objects of the scene.
                 *
                 *  @protected
                 *  @param {object} data Initialization parameters.
                 */



  create(/* data */) {

    this.created = true;

    let prevMute = localStorage.getItem('mute');
    this.mute = prevMute !== undefined ? prevMute === 'true' : false;
    this.toggleMute(this.mute);
    this.paused = false;
    this.helpConfig = this.cache.json.get('data').helpConfig;
    this.characterGroup = this.add.group();
    this.screenWidth = this.cameras.main.width;
    this.screenHeight = this.cameras.main.height;
    let x = this.screenWidth;
    let y = this.screenHeight;
    this.backgroundGroup = this.add.group();
    this.uiGroup = this.add.group();
    this.popupGroup = this.add.group();
    this.bg = this.add.image(x / 2, y / 2, 'blank');
    this.bg.setOrigin(0.5, 0.5);
    this.bg.setDisplaySize(x, y);
    this.bg.setDepth(-5);
    this.characters = [];
    this.helpPopup = new HelpPopup(this, this.popupGroup, this.helpConfig);
    this.pausePopup = new PausePopup(this, this.popupGroup);
    this.pausePopup.emitter.on('gameResumed', this.handleResumed, this);
    this.helpPopup.emitter.on('gameResumed', this.handleResumed, this);
    this.pausePopup.emitter.on('helpRequested', this.showHelp, this);
    this.pauseBtn = this.add.image(x - 10, 10, 'pauseBtn');
    this.pauseBtn.setOrigin(1, 0);
    this.pauseBtn
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => {
        if (this.paused === false) {
          this.handlePaused();
          if (this.pausePopup.active == false) {
            this.pausePopup.show(this);
          }
        }
      }, this);
    this.uiGroup.depth = 20;
    this.uiGroup.add(this.pauseBtn);
    this.popupGroup.depth = 30;

    this.toggleMute(this.mute);
    this.idleTime = 0;
    this.canIdle = true;
  }

  init() {
  }

  toggleMute(toggleOn) {
    this.mute = toggleOn;
    localStorage.setItem('mute', this.mute);
    this.sound.setMute(this.mute);
  }

  handlePaused() {
    this.paused = true;
    if (this.xyloButton !== undefined) {
      this.xyloButton.blocked = true;
    }
    if (this.endEvent !== undefined && this.endEvent !== null) {
      this.endEvent.paused = true;
    }
    if (this.bgEvent !== undefined && this.bgEvent !== null) {
      this.bgEvent.paused = true;
    }

    for (let i = 0; i < this.characters.length; i++) {
      this.characters[i].togglePause(true);
    }
  }

  handleResumed() {
    this.paused = false;

    if (this.xyloButton !== undefined) {
      this.xyloButton.blocked = false;
    }

    if (this.endEvent !== undefined) {
      this.endEvent.paused = false;
    }

    if (this.bgEvent !== undefined) {
      this.bgEvent.paused = false;
    }
    
    for (let i = 0; i < this.characters.length; i++) {
      this.characters[i].togglePause(false);
    }
  }

  showHelp(animate = true) {
    this.handlePaused();
    this.helpPopup.show(this, animate);
  }

  wrap(value, min, max) {
    if (value >= min && value <= max) {
      return value;
    } else if (value < min) {
      return max - (value - min);
    } else {
      return min + (value - max);
    }
  }

  /**
                 *  Called when a scene is updated. Updates to game logic, physics and game
                 *  objects are handled here.
                 *
                 *  @protected
                 *  @param {number} t Current internal clock time.
                 *  @param {number} dt Time elapsed since last update.
                 */
  update(t, dt) {
    if (this.paused === false && this.characters !== null) {
      for (var i = 0; i < this.characters.length; i++) {
        this.characters[i].updateCharacter(t, dt, this);
      }

      if (this.canIdle) {
        this.idleTime += dt;
        if (this.idleTime > 6000) {
          this.idleTime = 0;
          this.playIdle();
        }
      }
    }
  }

  playIdle() {

  }

  cleanup() {

    for (var i = this.characters.length - 1; i >= 0; i--) {
      this.characters[i].destroy();
      this.characters[i] = null;
    }
    this.characters = null;
    this.characterGroup.clear(true);
    this.characterGroup.destroy();
    // this.characterGroup = null;
    this.backgroundGroup.clear(true);
    this.backgroundGroup.destroy();
    // this.backgroundGroup = null;
    this.uiGroup.clear(true);
    this.uiGroup.destroy();
    // this.uiGroup = null;
    this.popupGroup.clear(true);
    this.popupGroup.destroy();
    // this.popupGroup = null;
  }
}
